/**
 * Club FeatureCarousel is closed while a waypoint or feature editor is open.
 * Always re-opening it on save made the old overlay appear after board/pin edits.
 */

export function shouldRestoreFeatureList(wasShowing) {
  return Boolean(wasShowing);
}

export function restoreFeatureListIfNeeded(wasShowing, onShow) {
  if (!shouldRestoreFeatureList(wasShowing)) return false;
  if (typeof onShow === 'function') onShow();
  return true;
}
